import { render, staticRenderFns } from "./ProductColors.vue?vue&type=template&id=205d962c&scoped=true&"
import script from "./ProductColors.vue?vue&type=script&lang=js&"
export * from "./ProductColors.vue?vue&type=script&lang=js&"
import style0 from "./ProductColors.vue?vue&type=style&index=0&id=205d962c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205d962c",
  null
  
)

export default component.exports